import React from 'react';
import { SearchBar } from './m3';

/* ============================================================================
 * ContentToolbar — 본문(ViewScroll) 최상단 툴바.
 *   Row1: 검색(SearchBar) ──flex── actions(추가/등록·CSV·복원·모두읽음 등)
 *   Row2: filters(필터 칩 행) — 있을 때만
 * 검색/액션/필터가 모두 없으면 아무것도 렌더하지 않는다.
 * ========================================================================= */

export interface ContentToolbarProps {
  search?: string;
  onSearch?: (v: string) => void;
  searchPlaceholder?: string;
  actions?: React.ReactNode;
  filters?: React.ReactNode;
}

export function ContentToolbar({
  search,
  onSearch,
  searchPlaceholder = '검색',
  actions,
  filters,
}: ContentToolbarProps): React.ReactElement | null {
  const hasRow1 = search !== undefined || actions != null;
  if (!hasRow1 && filters == null) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {hasRow1 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          {search !== undefined && (
            <SearchBar value={search} onChange={onSearch} placeholder={searchPlaceholder} width={280} />
          )}
          <div style={{ flex: 1, minWidth: 0 }} />
          {actions}
        </div>
      )}
      {filters != null && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>{filters}</div>
      )}
    </div>
  );
}
